import styled from 'styled-components';
import { Box, Anchor } from 'grommet';

const StyledPanel = styled(Box)`
  border-radius: var(--app-radius);
  box-shadow: var(--elevation);
  background: var(--page-card-bg);
  padding: 1rem;
`;

const StyledScrollPanel = styled(Box).attrs({ 'data-scroll-panel': 'true' })`
  max-height: 24rem;
  overflow-y: auto;
`;

const StyledChartWrap = styled(Box)`
  height: 19rem;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
  color: var(--page-table-text);

  thead th {
    position: sticky;
    top: 0;
    background: var(--page-card-bg);
    text-align: left;
    font-weight: 700;
    padding: 0.65rem 0.55rem;
    border-bottom: 1px solid var(--page-table-border);
    color: var(--page-table-header);
    white-space: nowrap;
  }

  tbody td {
    padding: 0.56rem 0.55rem;
    border-bottom: 1px solid var(--page-table-border);
    vertical-align: top;
    color: var(--page-table-text);
  }

  tbody tr:hover {
    background: var(--page-alt-bg);
  }
`;

const StyledPagedTableUrl = styled(Anchor)`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow:hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;

  &:hover { text-decoration: underline; }

  @media (max-width: 48em) {
    -webkit-line-clamp: 3;
  }
`;

export {
  StyledChartWrap,
  StyledPanel,
  StyledScrollPanel,
  StyledTable,
  StyledPagedTableUrl,
};
